module.exports = __webpack_public_path__ + "img/dunkin_donut.70a34a72.webp";